import { Organization } from '@/api';
import type { ApiResponseBase } from '@/models/common.models';
import { BaseModule } from '@/modules/common.module';
import { IntegrationInstallation } from '@/api';

export class IntegrationsModule extends BaseModule {
  constructor() {
    super('v1/organizations');
  }

  async proxy<T>(
    organizationId: Organization['id'],
    installationId: IntegrationInstallation['id'],
    url: string,
    data: {
      method: 'GET' | 'POST' | 'PUT' | 'DELETE';
      headers?: Record<string, string>;
      body?: unknown;
      queryParams?: Record<string, string>;
    }
  ): Promise<{
    status: number;
    headers: Record<string, string>;
    output: T | undefined; // in case of error
  }> {
    // extract query params from url
    const urlParts = url.split('?');
    const urlWithoutQueryParams = urlParts[0];
    const queryParams = urlParts[1]
      ? Object.fromEntries(new URLSearchParams(urlParts[1]).entries())
      : {};

    const response = await this.post<
      ApiResponseBase<{
        headers: Record<string, string>;
        status: number;
        output: T | undefined;
      }>
    >(`${organizationId}/integrations/${installationId}/proxy`, {
      url: urlWithoutQueryParams,
      ...data,
      queryParams: {
        ...queryParams,
        ...data.queryParams,
      },
    });

    return response.data.data;
  }
}
